import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiClient } from '../../../../api-client';
import { UnitResult } from '../../../../error';
import { CancelGuardJobShiftsRequest } from '../../../Domain/Port/CancelJobShifts/cancel-guard-job-shifts-request';
import { CancelJobShiftsService } from '../../../Domain/Port/CancelJobShifts/cancel-job-shifts.service';

/**
 * Backend implementation of the CancelJobShiftsService.
 *
 * This service handles cancelling job shifts by making API calls to the backend.
 * It transforms the domain request into a backend-compatible format and sends it
 * to the appropriate endpoint.
 */
@Injectable({
    providedIn: 'root'
})
export class BackendCancelJobShiftsService extends CancelJobShiftsService {
    /**
     * The API endpoint for cancelling job shifts.
     * The {id} placeholder will be replaced with the actual job ID.
     */
    private readonly endpoint = '/jobs/{id}/cancel';

    /**
     * Creates a new instance of BackendCancelJobShiftsService.
     *
     * @param apiClient - The API client used to make HTTP requests
     */
    constructor(private apiClient: ApiClient) {
        super();
    }

    /**
     * Cancels shifts for a job by making an API call to the backend.
     *
     * @param request - The request containing the job ID and shift IDs to cancel
     * @returns An Observable that emits a UnitResult indicating success or failure
     */
    override cancelJobShifts(request: CancelGuardJobShiftsRequest): Observable<UnitResult<void>> {
        const url = this.endpoint.replace('{id}', request.jobID.toString());
        return this.apiClient.post<CancelGuardJobShiftsRequest, void>(url, request, true);
    }
}
